import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const AngolaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14211'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14211)'>
				<rect
					width='20'
					height='14'
					fill='url(#paint0_linear_2332_14211)'
				/>
				<g filter='url(#filter0_d_2332_14211)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V7.46667H0V14Z'
						fill='#262626'
					/>
				</g>
				<g filter='url(#filter1_d_2332_14211)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 7.46667H20V0H0V7.46667Z'
						fill='#DD2137'
					/>
				</g>
				<g filter='url(#filter2_d_2332_14211)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M11.5703 8.08696C11.6891 7.88275 11.7834 7.66043 11.8484 7.42272C12.2568 5.92901 11.3523 4.39367 9.82812 3.99343C9.57409 3.92673 9.31298 4.07447 9.24491 4.32342C9.17684 4.57237 9.3276 4.82826 9.58163 4.89496C10.5978 5.16179 11.2008 6.18535 10.9285 7.18116C10.8911 7.31787 10.8392 7.44695 10.7748 7.56723L9.31222 6.61169C9.09339 6.46873 8.79774 6.52668 8.65186 6.74112C8.50598 6.95557 8.56511 7.24531 8.78393 7.38827L10.1248 8.26433C9.68812 8.54161 9.13785 8.64347 8.59565 8.50109C8.34162 8.43438 8.08051 8.58212 8.01244 8.83107C7.94437 9.08002 8.09512 9.33591 8.34916 9.40262C9.3014 9.65267 10.2702 9.40051 10.9628 8.81182L11.6411 9.25494C11.8599 9.3979 12.1555 9.33996 12.3014 9.12551C12.4473 8.91106 12.3882 8.62132 12.1694 8.47836L11.5703 8.08696ZM9.04807 6.06665C9.31107 6.06665 9.52426 5.85771 9.52426 5.59998C9.52426 5.34225 9.31107 5.13332 9.04807 5.13332C8.78508 5.13332 8.57188 5.34225 8.57188 5.59998C8.57188 5.85771 8.78508 6.06665 9.04807 6.06665Z'
						fill='#F8D84B'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14211'
					x='0'
					y='7.46667'
					width='20'
					height='6.53333'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14211'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14211'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_14211'
					x='0'
					y='0'
					width='20'
					height='7.46667'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14211'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14211'
						result='shape'
					/>
				</filter>
				<filter
					id='filter2_d_2332_14211'
					x='7.99609'
					y='3.97742'
					width='4.38477'
					height='6.52136'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14211'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14211'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2332_14211'
					x1='0'
					y1='0'
					x2='0'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#FF323E' />
					<stop
						offset='1'
						stopColor='#FD0D1B'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default AngolaFlagIcon;
